// extracted by mini-css-extract-plugin
export var priceTag = "PriceTag-module--priceTag--f3d4a";